const LS_USER_VIDEO_USAGE_ITEM = 'UserVideoUsageContentGates';
const SESSION_STORAGE_AUTO_PLAY_VIDEO_ITEM = 'VLPAutoPlayNextVideo';
const LOGGED_OUT_VIDEO_ALLOWANCE = 3;
const DEFAULT_VIDEO_WRAPPER_WIDTH = 780;
const DEFAULT_VLP_META_DESCRIPTION = 'The description goes here';

export {
  LS_USER_VIDEO_USAGE_ITEM,
  LOGGED_OUT_VIDEO_ALLOWANCE,
  SESSION_STORAGE_AUTO_PLAY_VIDEO_ITEM,
  DEFAULT_VIDEO_WRAPPER_WIDTH,
  DEFAULT_VLP_META_DESCRIPTION,
};
